export default __webpack_public_path__ + "static/media/doge.d2a33f7c.svg";